import { render, staticRenderFns } from "./ProtocolModal.vue?vue&type=template&id=7ef63852&scoped=true&"
import script from "./ProtocolModal.vue?vue&type=script&lang=js&"
export * from "./ProtocolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef63852",
  null
  
)

export default component.exports